export default {
  "content": "<g clip-path=\"url(#a)\"><path d=\"M5.805 7.029a.2.2 0 01.008.28L3.473 9.82a.554.554 0 01-.405.175.552.552 0 01-.403-.182L.428 7.319a.2.2 0 01.012-.28l.24-.223a.202.202 0 01.285.013l2.11 2.357 2.21-2.375a.2.2 0 01.285-.007l.235.225z\" fill=\"#8A8F9E\"/></g><g clip-path=\"url(#b)\"><path d=\"M.195 3.964a.2.2 0 01-.008-.28l2.34-2.513a.554.554 0 01.405-.175c.153.003.3.068.403.183l2.237 2.495a.2.2 0 01-.012.28l-.24.222a.202.202 0 01-.285-.012l-2.11-2.358-2.21 2.375a.2.2 0 01-.285.008l-.235-.225z\" fill=\"#8A8F9E\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 5h6v6H0z\"/></clipPath><clipPath id=\"b\"><path fill=\"#fff\" d=\"M0 0h6v6H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "6",
    "height": "11",
    "viewBox": "0 0 6 11",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};